import type { OrderOptionResponse } from "../../../../domain/types/orders";
import type { Order, OrderStatus } from "./types";

// API 상태 → UI 상태 매핑
export const apiStatusToUiStatus = (status: string): OrderStatus => {
  switch (status) {
    case "BEFORE_PAYMENT":
      return "pending_payment";
    case "RECEIVED":
      return "accepted";
    case "RE_RECEIVED":
      return "resubmission";
    case "IN_PRODUCTION":
      return "production";
    case "PRODUCTION_COMPLETED":
      return "production_complete";
    case "SHIPPED":
      return "shipping";
    case "DELIVERY_COMPLETED":
      return "delivered";
    case "CANCELLED":
      return "cancelled";
    case "REFUNDED":
      return "refunded";
    default:
      return "accepted";
  }
};

// UI 상태 → API 상태 매핑
export const uiStatusToApiStatus = (status: OrderStatus | "all"): string | undefined => {
  switch (status) {
    case "pending_payment": return "BEFORE_PAYMENT";
    case "accepted": return "RECEIVED";
    case "resubmission": return "RE_RECEIVED";
    case "production": return "IN_PRODUCTION";
    case "production_complete": return "PRODUCTION_COMPLETED";
    case "shipping": return "SHIPPED";
    case "delivered": return "DELIVERY_COMPLETED";
    case "cancelled": return "CANCELLED";
    case "refunded": return "REFUNDED";
    case "all":
    default: return undefined;
  }
};

// 백엔드 주문 데이터 → 프론트 Order 타입 매핑
export const mapApiOrderToView = (o: any): Order => {

  let mappedOptions: OrderOptionResponse[] = [];

  if (Array.isArray(o.options)) {
    if (o.options.length > 0) {
      if (typeof o.options[0] === 'string') {
        mappedOptions = o.options.map((opt: string) => ({
          optionName: "옵션",
          optionValue: opt,
          optionCount: 1,
          optionPrice: 0,
          optionTotalPrice: 0,
        }));
      } else {
        mappedOptions = o.options;
      }
    }
  }

  // purchaser가 객체인 경우와 직접 필드인 경우 모두 처리
  const customerName = o.purchaserName ?? o.purchaser?.name ?? "";
  const customerEmail = o.purchaserEmail ?? o.purchaser?.email ?? "";

  return {
    id: String(o.id),
    orderNumber: String(o.orderNumber ?? o.id),
    customerName,
    customerEmail,
    productName: o.name ?? "",
    quantity: o.productCount ?? 0,
    unitPrice: o.productPrice ?? 0,
    totalAmount: o.orderTotalAmount ?? 0,
    status: apiStatusToUiStatus(o.orderStatus),
    orderDate: (o.submittedAt ?? o.createdAt ?? "").toString().slice(0, 10),
    isLegacyDate: !o.submittedAt,
    dueDate: "",
    memo: o.memo,
    workTitle: o.workTitle ?? undefined,
    options: mappedOptions,
    files: o.orderSourceFile,
    paymentMethod: o.paymentMethod ?? null,
    attachments: Array.isArray(o.files) ? o.files : [],
  };
};

